import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { Collapse, Divider, Drawer, IconButton, List, ListItem, Typography, withStyles } from '@material-ui/core'

import AttachMoneyTwoToneIcon from '@material-ui/icons/AttachMoneyTwoTone';
import BuildTwoToneIcon from '@material-ui/icons/BuildTwoTone'
import CasinoTwoToneIcon from '@material-ui/icons/CasinoTwoTone';
import CategoryTwoToneIcon from '@material-ui/icons/CategoryTwoTone';
import CheckBoxTwoToneIcon from '@material-ui/icons/CheckBoxTwoTone';
import CheckCircleTwoToneIcon from '@material-ui/icons/CheckCircleTwoTone';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone';
import DirectionsTwoToneIcon from '@material-ui/icons/DirectionsTwoTone';
import EmojiEventsTwoToneIcon from '@material-ui/icons/EmojiEventsTwoTone'
import EventNoteTwoToneIcon from '@material-ui/icons/EventNoteTwoTone';
import ExitToAppTwoToneIcon from '@material-ui/icons/ExitToAppTwoTone';
import FastfoodTwoToneIcon from '@material-ui/icons/FastfoodTwoTone';
import FilterFramesTwoToneIcon from '@material-ui/icons/FilterFramesTwoTone';
import HighlightOffTwoToneIcon from '@material-ui/icons/HighlightOffTwoTone'
import HistoryTwoToneIcon from '@material-ui/icons/HistoryTwoTone';
import HomeTwoToneIcon from '@material-ui/icons/HomeTwoTone';
import ImageTwoToneIcon from '@material-ui/icons/ImageTwoTone';
import InboxTwoToneIcon from '@material-ui/icons/InboxTwoTone';
import InsertChartTwoToneIcon from '@material-ui/icons/InsertChartTwoTone';
import KitchenTwoToneIcon from '@material-ui/icons/KitchenTwoTone';
import LibraryAddCheckTwoToneIcon from '@material-ui/icons/LibraryAddCheckTwoTone';
import LocalAtmTwoToneIcon from '@material-ui/icons/LocalAtmTwoTone';
import LocalConvenienceStoreTwoToneIcon from '@material-ui/icons/LocalConvenienceStoreTwoTone'
import LocalOfferTwoToneIcon from '@material-ui/icons/LocalOfferTwoTone'
import LocalMallTwoToneIcon from '@material-ui/icons/LocalMallTwoTone';
import MessageTwoToneIcon from '@material-ui/icons/MessageTwoTone';
import MonetizationOnTwoToneIcon from '@material-ui/icons/MonetizationOnTwoTone';
import NotificationsTwoToneIcon from '@material-ui/icons/NotificationsTwoTone';
import PeopleOutlineTwoToneIcon from '@material-ui/icons/PeopleOutlineTwoTone';
import PersonOutlineTwoToneIcon from '@material-ui/icons/PersonOutlineTwoTone';
import ReceiptTwoToneIcon from '@material-ui/icons/ReceiptTwoTone';
import ShoppingCartTwoToneIcon from '@material-ui/icons/ShoppingCartTwoTone';
import StoreTwoToneIcon from '@material-ui/icons/StoreTwoTone'
import SwapHorizTwoToneIcon from '@material-ui/icons/SwapHorizTwoTone';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone'
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import VpnKeyIcon from '@material-ui/icons/VpnKey'

import { authActions, sidebarAction } from '../../../../_actions'
import { connect, useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Profile, SidebarNav } from './components'

import packageInfo from '../../../../../package.json'

const styles = (theme) => ({
  drawer: {
    flexShrink: 0,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  drawerOpen: {
    width: 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  nav: {
    marginBottom: theme.spacing(1)
  }
})

const Sidebar = ({ staticContext, ...props }) => {
  const { user, type, open, isDesktop, onClose, classes, className, onCollapse, ...rest } = props
  const dispatch = useDispatch()

  const [openMenuPedidos, setOpenMenuPedidos] = useState(false);
  const [openMenuFidelidades, setOpenMenuFidelidades] = useState(false);
  const [openMenuCadastros, setOpenMenuCadastros] = useState(false);
  const [openMenuOperacao, setOpenMenuOperacao] = useState(false);
  const [openMenuCustos, setOpenMenuCustos] = useState(false);

  const [isClickedOptionSubmenu, setIsClickedOptionSubMenu] = useState(false);

  const openSidebar = useSelector((state) => state.sidebar.openSidebar);

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isDesktop) {
      onCollapse(true);
      dispatch(sidebarAction.setOpen(true))
    }
  }, [isDesktop])

  const logout = () => {
    dispatch(authActions.logout())
  }

  const isDisabled = useSelector((state) => {
    return false
  })

  const handleDrawerOpen = () => {
    dispatch(sidebarAction.setOpen(true))
    onCollapse(true);
  };

  const handleDrawerClose = () => {
    dispatch(sidebarAction.setOpen(false))
    onCollapse(false);
  };

  const handleClickPedidos = () => {
    setOpenMenuPedidos(!openMenuPedidos);
  };

  const handleClickOperacao = () => {
    setOpenMenuOperacao(!openMenuOperacao);
  };

  const handleClickCadastros = () => {
    setOpenMenuCadastros(!openMenuCadastros);
  };

  const pagesFidelidadesItens = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      divider: true,
      title: 'Home',
      href: '#',
      rule: 'dashboard.view',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade')
      },
      icon: <HomeTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Banners',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/banners')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'banners',
      icon: <ImageTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Campanhas',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/campanhas')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'campanhas',
      icon: <EventNoteTwoToneIcon />,
      isNew: true
    },
    {
      title: 'Categorias Produtos',
      href: `/categoriasProdutos`,
      rule: 'categoriasCompras',
      clickedSub: isClickedOptionSubmenu,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <CategoryTwoToneIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Clientes',
      href: '#',
      rule: 'dashboard.view',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/clientes')
      },
      icon: <PeopleOutlineTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Metas',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/metas')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'metas',
      icon: <TrackChangesIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Notificações',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/notificacoes')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'notificacoes',
      icon: <NotificationsTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Sorteios',
      divider: true,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/sorteios')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'sorteios',
      icon: <CasinoTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Ranking',
      href: '#',
      rule: 'relatorios.list',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/relatorios/ranking')
      },
      icon: <EmojiEventsTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/relatorios/pontos')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Pontos',
      href: '#',
      rule: 'relatorios.admin',
      icon: <DescriptionTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/fidelidade/relatorios/trocas')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Trocas',
      href: '#',
      rule: 'relatorios.list',
      icon: <SwapHorizTwoToneIcon />,
      isNew: true
    }
  ]

  const pagesPedidosItens = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Pedidos de Compra',
      href: '#',
      divider: true,
      rule: 'pedidosCompras',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/compras')
      },
      icon: <ShoppingBasketTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Planilhas de Contagem',
      clickedSub: isClickedOptionSubmenu,
      href: '/checklists',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      rule: 'checklists',
      icon: <CheckBoxTwoToneIcon />
    },
    {
      disabled: isDisabled,
      title: 'Fornecedores',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/fornecedores')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'fornecedores',
      icon: <LocalMallTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Grupos de Fornecedores',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/grupos-fornecedores')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'gruposFornecedores',
      icon: <StoreTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/insumos')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Insumos',
      href: '#',
      rule: 'totvsInsumos',
      icon: <FastfoodTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Listas de Preços',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/listas-precos')
      },
      rule: 'listasPrecos',
      icon: <LocalOfferTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Perdas de Insumos',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/entradas-saidas-estoque')
      },
      rule: 'movimentosInsumos',
      icon: <HighlightOffTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/unidades-insumos')
      },
      divider: true,
      clickedSub: isClickedOptionSubmenu,
      title: 'Unidades de Insumos',
      href: '#',
      rule: 'totvsInsumosUnidades',
      icon: <KitchenTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/relatorios/contagem-estoque')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Contagem de Estoque',
      href: '#',
      rule: 'relatorios.list',
      icon: <InboxTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/relatorios/divergencias-ficha-tecnica')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Divergências FT',
      href: '#',
      rule: 'relatorios.admin',
      icon: <ReceiptTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Fornecedores de Insumos',
      href: '/relatorioTotvsInsumosUnidadesFornecedores',
      rule: 'relatorios.list',
      icon: <FilterFramesTwoToneIcon />
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/relatorios/nivel-servico')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Nível de Serviço',
      href: '#',
      rule: 'relatorios.admin',
      icon: <InsertChartTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/relatorios/venda-insumo')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Venda de Insumos',
      href: '#',
      rule: 'relatorios.list',
      icon: <AttachMoneyTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/suprimentos/relatorios/venda-produto')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Venda de Produtos',
      href: '#',
      rule: 'relatorios.list',
      icon: <AttachMoneyTwoToneIcon />,
      isNew: true
    }
  ]

  const pagesOperacao = [
    {
      disabled: isDisabled,
      title: 'Checklists de Operação',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/operacao/checklist-operacao/execucao')
      },
      rule: 'checklistsOperacoes',
      icon: <CheckBoxTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Cadastro de Checklists de Operação',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/operacao/checklist-operacao')
      },
      rule: 'checklistsOperacoes.edit',
      icon: <LibraryAddCheckTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Equipamentos',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/operacao/equipamentos')
      },
      rule: 'checklistsOperacoes',
      icon: <KitchenTwoToneIcon />,
      isNew: true
    },
    {
      divider: true,
      disabled: isDisabled,
      title: 'Etiquetas',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/operacao/etiquetas')
      },
      rule: 'etiquetas',
      icon: <LocalOfferTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      href: '#',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/operacao/relatorios/impressao-checklists')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Impressões de Checklists',
      rule: 'relatorios.admin',
      icon: <DescriptionTwoToneIcon />,
      isNew: true
    }
  ]

  const pagesCustos = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      divider: true,
      title: 'Home',
      href: '#',
      rule: 'dashboard.view',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos')
      },
      icon: <HomeTwoToneIcon />,
      isNew: true
    },
    {
      title: 'Categorias Compras',
      href: '#',
      rule: 'categoriasCompras',
      clickedSub: isClickedOptionSubmenu,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/categorias-compras')
      },
      icon: <CategoryTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Compras',
      href: '#',
      divider: true,
      rule: 'compras',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/compras')
      },
      icon: <ShoppingBasketTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório Comparativo de Preços',
      href: '#',
      rule: 'relatorios.list',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/relatorios/comparativo-precos')
      },
      icon: <EmojiEventsTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório Compras x Vendas',
      href: '#',
      rule: 'relatorios.list',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/relatorios/compra-venda')
      },
      icon: <ShoppingCartTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório Compras',
      href: '#',
      rule: 'relatorios.admin',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/relatorios/compras')
      },
      icon: <LocalAtmTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório Conversões',
      href: '#',
      rule: 'relatorios.admin',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/relatorios/conversoes')
      },
      icon: <DirectionsTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório Preços',
      href: '#',
      rule: 'relatorios.admin',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/custos/relatorios/precos')
      },
      icon: <MonetizationOnTwoToneIcon />,
      isNew: true
    }
  ]

  const pagesCadastrosItens = [
    {
      title: 'Certificados',
      href: '#',
      rule: 'certificados',
      clickedSub: isClickedOptionSubmenu,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/certificados')
      },
      icon: <CheckCircleTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Grupos',
      href: '#',
      rule: 'grupos',
      clickedSub: isClickedOptionSubmenu,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/grupos')
      },
      icon: <StoreTwoToneIcon />,
      isNew: true
    },
    {
      title: 'Lojas',
      href: '#',
      clickedSub: isClickedOptionSubmenu,
      rule: 'lojas',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/lojas')
      },
      icon: <LocalConvenienceStoreTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/mensagens')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Mensagens/Alertas',
      href: '#',
      rule: 'mensagens',
      icon: <MessageTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Permissões',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/tipos-usuarios')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'permissoes',
      icon: <VpnKeyIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Produtos',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/produtos')
      },
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'produtos',
      icon: <ShoppingBasketTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      title: 'Unidades',
      href: '#',
      rule: 'unidades',
      clickedSub: isClickedOptionSubmenu,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/unidades')
      },
      icon: <KitchenTwoToneIcon />,
      isNew: true
    },
    {
      title: 'Usuários',
      href: '#',
      rule: 'usuarios',
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/usuarios')
      },
      clickedSub: isClickedOptionSubmenu,
      icon: <PersonOutlineTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/parametros')
      },
      title: 'Parâmetros',
      clickedSub: isClickedOptionSubmenu,
      href: '#',
      rule: 'parametros',
      divider: true,
      icon: <BuildTwoToneIcon />,
      isNew: true
    },
    {
      disabled: isDisabled,
      onClick: () => {
        window.location.assign('https://quiero.q2f.com.br/modulos/gerencia/relatorios/logs')
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Relatório de Logs',
      href: '#',
      rule: 'relatorios.admin',
      icon: <HistoryTwoToneIcon />,
      isNew: true
    }
  ]

  const pagesSair = [
    {
      title: 'Sair',
      href: '/login',
      icon: <ExitToAppTwoToneIcon />,
      onClick: () => {
        logout()
      }
    }
  ]

  const pagesList = [
    {
      type: 'F',
      pages: pagesFidelidadesItens,
      menu: openMenuFidelidades,
    },
    {
      type: 'P',
      pages: pagesPedidosItens,
      menu: openMenuPedidos
    },
    {
      type: 'O',
      pages: pagesOperacao,
      menu: openMenuOperacao
    },
    {
      type: 'C',
      pages: pagesCustos,
      menu: openMenuCustos
    },
    {
      type: 'G',
      pages: pagesCadastrosItens,
      menu: openMenuCadastros
    }
  ]

  return (
    <Drawer
      onClose={onClose}
      open={open}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      variant={isDesktop ? 'permanent' : 'temporary'}
      classes={{
        paper: clsx(
          classes.drawer,
          {
            [classes.drawerOpen]: openSidebar,
            [classes.drawerClose]: !openSidebar
          }
        )
      }}
    >
      <PerfectScrollbar>
        <div {...rest} className={clsx(classes.root, className)} style={{ position: 'relative' }}>
          <Profile user={user} isOpen={openSidebar} />

          <Divider className={classes.divider} />

          {pagesList.map((item, index) => (
            type == item.type &&
              <>
                <SidebarNav pages={item.pages} isOpen={openSidebar} style={{ paddingTop: 0 }} />
                <div>
                  <Collapse in={item.menu} timeout="auto">
                    <List component="div" disablePadding>
                      <ListItem style={{ paddingTop: 0 }}>
                        <SidebarNav pages={item.pages} />
                      </ListItem>
                    </List>
                  </Collapse>
                </div>
              </>
          ))}

          <Typography variant="body2" align="center">
            {openSidebar ? `Versão do sistema: ${packageInfo.version}` : `v${packageInfo.version}`}
          </Typography>

          {isDesktop && isHovered && (
            <div style={{ position: 'absolute', top: '50%', right: openSidebar ? 5 : 0 }}>
              <IconButton
                size="small"
                onClick={() => openSidebar ? handleDrawerClose() : handleDrawerOpen()}
              >
                {openSidebar ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
          )}
        </div>
      </PerfectScrollbar>
    </Drawer>
  )
}

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  type: PropTypes.string,
  onCollapse: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    user: state.authentication.user
  }
}
const connectedSidebarPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(Sidebar))
)
export { connectedSidebarPage as Sidebar }
